import { h } from 'preact';
import bemNamespace from '../../utils/bemNamespace';

export const bem = bemNamespace('select');

const SelectOption = (props) => {
  const {
    title,
    children,
    onSelect,
    className,
    selectedIndex,
    dataQa = null,
    label = '',
    telemetryData,
    ariaExpanded,
    ariaHasPopup,
    ariaSelected,
    role,
  } = props;

  const isValidAriaExpanded = !!ariaExpanded && (typeof ariaExpanded) === 'boolean';
  const isValidAriaSelected = !!ariaSelected && (typeof ariaSelected) === 'boolean';

  /* Optional shared aria-* props for button as listbox trigger / button as listbox option */
  const ariaAttributes = {
    ...(!!label && { 'aria-label': label }),
    ...(isValidAriaExpanded && { 'aria-expanded': ariaExpanded ? 'true' : 'false' }),
    ...(!!ariaHasPopup && { 'aria-haspopup': ariaHasPopup }),
    ...(isValidAriaSelected && { 'aria-selected': ariaSelected ? 'true' : 'false' }),
    ...(!!role && { role }),
  };

  return (
    <button
      {...ariaAttributes}
      className={className}
      type="button"
      onClick={onSelect}
      data-selected-index={selectedIndex}
      data-telemetry={telemetryData}
      data-qa={dataQa}
    >
      <span className={bem('label-title')}>{title}</span>
      {children}
    </button>
  );
};

export default SelectOption;
